import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="bg-azul-noche py-8 px-6" data-id="element-147">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-148">
          <p className="text-white/50 text-sm" data-id="element-149">
            © {new Date().getFullYear()} Duerme, Bebé. Duerme. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center gap-6" data-id="element-150">
            <button onClick={() => setActiveModal('privacy')} className="text-white/50 text-sm hover:text-white transition-colors underline underline-offset-2" data-id="element-151">
              Privacy Policy
            </button>
            <button onClick={() => setActiveModal('terms')} className="text-white/50 text-sm hover:text-white transition-colors underline underline-offset-2" data-id="element-152">
              Terms & Conditions
            </button>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-153">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-154">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3
        }} className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-155">
              <div className="sticky top-0 bg-white border-b border-gray-100 p-6 flex items-center justify-between rounded-t-2xl" data-id="element-156">
                <h2 className="text-2xl font-bold text-azul-noche font-serif" data-id="element-157">
                  {activeModal === 'privacy' ? 'Privacy Policy' : 'Terms & Conditions'}
                </h2>
                <button onClick={() => setActiveModal(null)} className="w-10 h-10 rounded-full bg-crema flex items-center justify-center hover:bg-gray-200 transition-colors" data-id="element-158">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1B2A4A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-159">
                    <line x1="18" y1="6" x2="6" y2="18" data-id="element-160"></line>
                    <line x1="6" y1="6" x2="18" y2="18" data-id="element-161"></line>
                  </svg>
                </button>
              </div>

              <div className="p-6 text-texto space-y-6 text-base leading-relaxed" data-id="element-162">
                {activeModal === 'privacy' ? <>
                    <p className="text-sm text-texto/60" data-id="element-163">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-164">
                      1. Información que Recopilamos
                    </h3>
                    <p data-id="element-165">
                      Recopilamos información personal que usted nos proporciona
                      directamente al realizar una compra, incluyendo su nombre,
                      dirección de correo electrónico e información de pago. No
                      almacenamos datos de tarjetas de crédito directamente;
                      estos son procesados de forma segura por nuestro proveedor
                      de pagos.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-166">
                      2. Uso de la Información
                    </h3>
                    <p data-id="element-167">
                      Utilizamos su información personal para: procesar y
                      entregar su compra digital, enviar comunicaciones
                      relacionadas con su pedido, mejorar nuestros productos y
                      servicios, y cumplir con obligaciones legales.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-168">
                      3. Protección de Datos
                    </h3>
                    <p data-id="element-169">
                      Implementamos medidas de seguridad técnicas y
                      organizativas apropiadas para proteger su información
                      personal contra acceso no autorizado, alteración,
                      divulgación o destrucción.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-170">
                      4. Cookies
                    </h3>
                    <p data-id="element-171">
                      Nuestro sitio web puede utilizar cookies y tecnologías
                      similares para mejorar su experiencia de navegación y
                      analizar el tráfico del sitio. Puede configurar su
                      navegador para rechazar cookies.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-172">
                      5. Terceros
                    </h3>
                    <p data-id="element-173">
                      No vendemos, comercializamos ni transferimos su
                      información personal a terceros, excepto a proveedores de
                      servicios de confianza que nos asisten en la operación de
                      nuestro sitio web y negocio, siempre que dichas partes
                      acuerden mantener esta información confidencial.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-174">
                      6. Sus Derechos
                    </h3>
                    <p data-id="element-175">
                      Usted tiene derecho a acceder, corregir o eliminar su
                      información personal. También puede solicitar la
                      portabilidad de sus datos o retirar su consentimiento en
                      cualquier momento.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-176">
                      7. Cambios a Esta Política
                    </h3>
                    <p data-id="element-177">
                      Nos reservamos el derecho de actualizar esta política de
                      privacidad en cualquier momento. Los cambios serán
                      publicados en esta página con una fecha de actualización
                      revisada.
                    </p>
                  </> : <>
                    <p className="text-sm text-texto/60" data-id="element-178">
                      Última actualización:{' '}
                      {new Date().toLocaleDateString('es-ES', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-179">
                      1. Aceptación de los Términos
                    </h3>
                    <p data-id="element-180">
                      Al acceder y utilizar este sitio web y al realizar una
                      compra de nuestros productos digitales, usted acepta estar
                      sujeto a estos Términos y Condiciones. Si no está de
                      acuerdo con alguna parte de estos términos, no debe
                      utilizar nuestro sitio.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-181">
                      2. Producto Digital
                    </h3>
                    <p data-id="element-182">
                      "Duerme, Bebé. Duerme." es un producto de información
                      digital (guía en formato PDF). El contenido es educativo y
                      no sustituye el consejo médico profesional. Siempre
                      consulte con su pediatra antes de implementar cambios en
                      la rutina de sueño de su bebé.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-183">
                      3. Entrega del Producto
                    </h3>
                    <p data-id="element-184">
                      Tras completar su compra, recibirá acceso inmediato al
                      producto digital a través de un enlace de descarga enviado
                      a su correo electrónico. Es su responsabilidad
                      proporcionar una dirección de correo electrónico válida.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-185">
                      4. Política de Reembolso
                    </h3>
                    <p data-id="element-186">
                      Ofrecemos una garantía de devolución de dinero de 30 días.
                      Si después de aplicar consistentemente las estrategias de
                      la guía no ve mejoras en el sueño de su bebé, puede
                      solicitar un reembolso completo sin preguntas.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-187">
                      5. Propiedad Intelectual
                    </h3>
                    <p data-id="element-188">
                      Todo el contenido de este sitio web y del producto
                      digital, incluyendo textos, gráficos, logotipos e
                      imágenes, es propiedad de Duerme, Bebé. Duerme. y está
                      protegido por las leyes de propiedad intelectual. Queda
                      prohibida la reproducción, distribución o reventa del
                      contenido sin autorización expresa.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-189">
                      6. Limitación de Responsabilidad
                    </h3>
                    <p data-id="element-190">
                      Los resultados pueden variar. No garantizamos resultados
                      específicos ya que cada bebé es diferente. La guía
                      proporciona estrategias basadas en evidencia científica,
                      pero los resultados dependen de múltiples factores
                      individuales.
                    </p>

                    <h3 className="font-bold text-azul-noche text-lg" data-id="element-191">
                      7. Ley Aplicable
                    </h3>
                    <p data-id="element-192">
                      Estos términos se regirán e interpretarán de acuerdo con
                      las leyes de los Estados Unidos de América, sin tener en
                      cuenta sus disposiciones sobre conflictos de leyes.
                    </p>
                  </>}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}